import { render, staticRenderFns } from "./banner-list.vue?vue&type=template&id=37c117ee&scoped=true&"
import script from "./banner-list.vue?vue&type=script&lang=js&"
export * from "./banner-list.vue?vue&type=script&lang=js&"
import style0 from "./banner-list.vue?vue&type=style&index=0&id=37c117ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c117ee",
  null
  
)

export default component.exports